export default __webpack_public_path__ + "dc3cbd21104d40477da6454089dfbd0c.ttf";